import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import pl from "vuetify/es5/locale/pl";
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // change icons to newer version
// import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify, {
	iconfont: "md",
	lang: {
		locales: {pl},
		current: "pl",
	},
	theme: {
		primary: '#0052A5',
		secondary: '#656565',
		accent: '#0052A5',
		success: '#0075E2',
		error: '#D5233F',
		red: 'A7162D',
		grey: '#B7B7B7',
		blue: '#0075E2',
		white: '#ffffff',
		lightred: '#D5233F',
		black: '#1B1B1B',
	},
});
